import { isNil } from 'lodash';
import { View } from '@shared/components/View';
import { TextInput } from '@shared/components/textInput';
import { useWorkflowDispatch } from '@shared/scenes/workflows/context/context';
import { API } from '@shared/types/api';

interface Props {
  component: API.TextComponent;
}

export function DefaultTextRow({ component }: Props) {
  const dispatch = useWorkflowDispatch();

  const onChangeText = (value: string) => {
    dispatch({
      type: 'updateComponent',
      args: {
        ...component,
        default: isNil(value) ? null : { text: value },
      } as API.TextComponent,
    });
  };

  return (
    <View paddingHorizontal={3} paddingVertical={1}>
      <TextInput value={component.default?.text} onChangeText={onChangeText} />
    </View>
  );
}
